import { createUseStyles } from 'react-jss';
import type { Theme } from '@wds/styles';

const useStyles = createUseStyles(({ spacing, border, palette }: Theme) => ({
  linkList: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: 0,
    padding: `${spacing['6']}px 10% 0`,
    listStyleType: 'none',

    '& > li': {
      flexGrow: 1,
      flexBasis: 'auto',
      textAlign: 'center',
      borderRight: border.border,
      backgroundColor: palette.text.light,

      '&:last-child': {
        borderRight: 'none',
      },
    },
  },
}));

export default useStyles;
